import type { Employer } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

const EXCLUDED_KEYS = new Set(['banner_media_url', 'logo_media_url']);

export const useAgentContext = (employer?: Employer) => {
  useRegisterAgentContext(
    employer
      ? {
          kind: 'entity',
          description: 'The employer the user is viewing',
          data: Object.fromEntries(Object.entries(employer).filter(([k]) => !EXCLUDED_KEYS.has(k))),
        }
      : null,
  );
};
